import { render } from "./InputBox.vue?vue&type=template&id=0dd6e654&scoped=true"
import script from "./InputBox.vue?vue&type=script&lang=js"
export * from "./InputBox.vue?vue&type=script&lang=js"

import "./InputBox.vue?vue&type=style&index=0&id=0dd6e654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd6e654"]])

export default __exports__